import axios, { defaultParams } from './axios';
export default function get(url, config) {
    const mergedConfig = { ...defaultParams(), ...(config ?? {}) };
    return axios.get(url, mergedConfig);
}
